/**
 * @module pricing
 */

module.exports = function() {
    const productsList = document.querySelector( '.products-list' ),
        productItems = document.querySelectorAll( 'input.product-item' ),
        userInfoTitle = document.querySelector( '.user-info-title' ),
        featureValue = document.querySelectorAll( '.feature-value' ),
        pricingSubmitBtn = document.querySelector( '.pricing-form .wpcf7-submit' ),
        checkboxes = document.querySelector( 'input[name="checkboxes[]"]' );

    let productSlug;
    let firstSend = false;

    productsList.classList.toggle( 'd-flex' );
    productsList.classList.toggle( 'd-none' );

    function deleteErrorMessage( error ) {
        checkboxes.checked = false;
        document.querySelectorAll( '.' + error ).forEach( ( er ) => {
            er.classList.toggle( 'd-none', true );
        } );
    }

    productItems.forEach( ( item ) => item.addEventListener( 'change', function() {
        productSlug = `.${ this.getAttribute( 'product-name' ) }`;
        const productSlugItem = document.querySelector( productSlug ),
            productSlugInput = document.querySelector( `${ productSlug } input` );

        deleteErrorMessage( 'products-list-error' );

        const toogleSlugItem = () => {
            productSlugItem.classList.toggle( 'd-none' );
            productSlugItem.classList.toggle( 'd-block' );
        };

        if ( this.checked ) {
            userInfoTitle.prepend( productSlugItem );
            toogleSlugItem();
        } else {
            productSlugInput.checked = false;
            toogleSlugItem();
        }
    } ) );

    featureValue.forEach( ( item ) => item.addEventListener( 'click', function() {
        deleteErrorMessage( 'features-error' );
        this.checked ? this.value = this.dataset.price : this.value = '';
    } ) );

    // errors

    function errorChecking() {
        const productsError = document.querySelector( '.products-list-error' ),
            productFeatures = document.querySelectorAll( '.product-features' ),
            formId = document.querySelector( '.pricing-form' ).getAttribute( 'form-id' );

        if ( this === pricingSubmitBtn || firstSend ) {
            for ( const item of productItems ) {
                if ( item.checked ) {
                    productsError.classList.add( 'd-none' );
                    break;
                } else {
                    productsError.classList.remove( 'd-none' );
                }
            }

            productFeatures.forEach( ( item, index ) => {
                const productFeaturesBlock = productFeatures[ index ],
                    productFeaturesBlockInput = document.querySelectorAll( `.${ productFeaturesBlock.classList[ 0 ] } input` ),
                    featuresError = document.querySelector( `.${ productFeaturesBlock.classList[ 0 ] } .features-error` );

                if ( productFeaturesBlock.classList.contains( 'd-block' ) ) {
                    for ( const i of productFeaturesBlockInput ) {
                        if ( i.checked ) {
                            featuresError.classList.add( 'd-none' );
                            return false;
                        }
                        featuresError.classList.remove( 'd-none' );
                    }
                }
            } );
        }

        setTimeout( function() {
            pricingSubmitBtn.disabled = true;
        }, 10 );

        document.addEventListener( 'wpcf7submit', function() {
            setTimeout( function() {
                firstSend = true;
                pricingSubmitBtn.removeAttribute( 'disabled' );
            }, 20 );
        }, false );

        document.addEventListener( 'wpcf7mailsent', function( event ) {
            if ( formId == event.detail.contactFormId ) {
                document.getElementById( 'pricingForm' ).setAttribute( 'style', 'display:none !important' );
                document.getElementById( 'successSubmitForm' ).setAttribute( 'style', 'display:flex !important' );
                document.getElementById( 'line' ).scrollIntoView();
            }
        }, false );

        checkboxes.checked = ! document.querySelector( '.error-message:not(.d-none)' );
        if ( firstSend ) {
            checkboxes.click();
        }
    }

    document.querySelectorAll( '.wpcf7-form label, .feature-value' ).forEach( ( label ) => label.addEventListener( 'click', errorChecking ) );
    pricingSubmitBtn.addEventListener( 'click', errorChecking );

    window.onunload = () => {
        document.querySelectorAll( 'input' ).forEach( ( input ) => input.checked = false );
    };
}; // exports
